/**
 * @description: 取酒明细报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="war-qjm-report">
        <div class="qm-list">
            <el-form :inline="true" size="small" :model="qm_list_form">
                <el-form-item label="时间">
                    <div class="clearfix" ref="qm_list_date">
                        <el-col :span="11">
                            <el-input placeholder="开始时间" v-model="qm_list_form.start_date"></el-input>
                        </el-col>
                        <el-col class="el-line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-input placeholder="结束时间" v-model="qm_list_form.end_date"></el-input>
                        </el-col>
                    </div>
                </el-form-item>
                <el-form-item label="寄存门店">
                    <el-input v-model="qm_deposit_names" class="el-ellipsis" clearable placeholder="请选择寄存门店" @focus="qmDepositSelect" @clear="qmDepositDel"></el-input>
                </el-form-item>
                <el-form-item label="取酒门店">
                    <el-select v-model="qm_list_form.shop_id" filterable clearable placeholder="请选择取酒门店" @change="shopChange">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="取酒仓库">
                    <el-select v-model="qm_list_form.store_id" filterable clearable placeholder="请选择取酒仓库" :disabled="qm_list_form.store_disabled">
                        <el-option v-for="item in store_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商品类型">
                    <el-select v-model="qm_list_form.goods_type" filterable clearable placeholder="请选择商品类型">
                        <el-option v-for="item in goods_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="寄存单号">
                    <el-input v-model="qm_list_form.relation_id" placeholder="请输入寄存单号"></el-input>
                </el-form-item>
                <el-form-item label="手机号">
                    <el-input v-model="qm_list_form.mobile" placeholder="请输入手机号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input placeholder="请输入内容" v-model="qm_list_form.content">
                        <el-select class="el-slot-select" v-model="qm_list_form.select" slot="prepend" placeholder="请选择">
                            <el-option label="取酒员工" value="take_admin_name"></el-option>
                            <el-option label="取酒员工手机" value="take_admin_mobile"></el-option>
                        </el-select>
                    </el-input>
                </el-form-item>
                <el-form-item label="操作人">
                    <el-select v-model="qm_list_form.take_operation_admin_id" filterable clearable placeholder="请选择操作人">
                        <el-option v-for="item in operator_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="qmQuery">查询</el-button>
                    <el-button @click="qmExportSet">导出</el-button>
                </el-form-item>
            </el-form>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="qm_list">
                <el-table-column type="index" label="行号"></el-table-column>
                <el-table-column prop="time" width="100" label="取酒时间"></el-table-column>
                <el-table-column prop="take_admin_name" width="130" label="取酒员工"></el-table-column>
                <el-table-column prop="take_admin_mobile" label="取酒员工手机"></el-table-column>
                <el-table-column prop="room_name" label="取酒包厢"></el-table-column>
                <el-table-column prop="relation_id" width="110" label="寄存单号"></el-table-column>
                <el-table-column prop="mobile" label="手机号"></el-table-column>
                <el-table-column prop="goods_type_name" label="商品类型"></el-table-column>
                <el-table-column width="130" label="商品名称">
                    <template slot-scope="scope">
                        {{scope.row.goods_name.length > '14' ? scope.row.goods_name.slice(0, 14) + '...' : scope.row.goods_name}}
                    </template>
                </el-table-column>
                <el-table-column prop="goods_unit_name" label="单位"></el-table-column>
                <el-table-column prop="quantity" label="取酒数量"></el-table-column>
                <el-table-column width="130" label="取酒门店">
                    <template slot-scope="scope">
                        {{scope.row.shop_name.length > '14' ? scope.row.shop_name.slice(0, 14) + '...' : scope.row.shop_name}}
                    </template>
                </el-table-column>
                <el-table-column prop="store_name" label="取酒仓库"></el-table-column>
                <el-table-column prop="operation_admin_name" label="操作人"></el-table-column>
                <el-table-column prop="deposit_shop_name" label="寄存门店">
                    <template slot-scope="scope">
                        {{scope.row.deposit_shop_name.length > '14' ? scope.row.deposit_shop_name.slice(0, 14) + '...' : scope.row.deposit_shop_name}}
                    </template>
                </el-table-column>
                <el-table-column prop="buying_price" label="进货单价"></el-table-column>
                <el-table-column prop="buying_price_total" label="进货价合计"></el-table-column>
            </el-table>
            <div class="pagination-row">
                <div>
                    <label class="list-label-4">取酒总量:</label>
                    <div class="list-total">{{qm_quantity_total}}</div>
                    <label class="list-label-4">进货总价:</label>
                    <div class="list-total">{{qm_buying_price_total}}</div>
                </div>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :page-size="GLOBAL.PAGESIZE"
                    :current-page.sync="qm_list_page"
                    :total="qm_list_total"
                    @current-change="getQmList">
                </el-pagination>
            </div>
            <!-- 寄存门店弹窗 -->
            <div class="export-wrap" ref="qm_deposit_shop">
                <el-checkbox :indeterminate="qm_deposit_sign" v-model="qm_deposit_all" @change="qmDepositAll">全选</el-checkbox>
                <el-checkbox-group v-model="qm_deposit_ids" @change="qmDepositChange">
                    <el-checkbox v-for="item in shop_list" :key="item.id" :label="item.id">{{item.name}}</el-checkbox>
                </el-checkbox-group>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="export-wrap" ref="qm_list_export">
                <h3>请选择导出报表需要的显示的字段</h3>
                <el-checkbox :indeterminate="qm_export_sign" v-model="qm_export_all" @change="qmExportAll">全选</el-checkbox>
                <el-checkbox-group v-model="qm_export_ids" @change="qmExportChange">
                    <el-checkbox label="time">取酒时间</el-checkbox>
                    <el-checkbox label="take_admin_name">取酒员工</el-checkbox>
                    <el-checkbox label="take_admin_mobile">取酒员工手机</el-checkbox>
                    <el-checkbox label="room_name">取酒包厢</el-checkbox>
                    <el-checkbox label="relation_id">寄存单号</el-checkbox>
                    <el-checkbox label="mobile">手机号</el-checkbox>
                    <el-checkbox label="goods_type_name">商品类型</el-checkbox>
                    <el-checkbox label="goods_name">商品名称</el-checkbox>
                    <el-checkbox label="goods_unit_name">单位</el-checkbox>
                    <el-checkbox label="quantity">取酒数量</el-checkbox>
                    <el-checkbox label="shop_name">取酒门店</el-checkbox>
                    <el-checkbox label="store_name">取酒仓库</el-checkbox>
                    <el-checkbox label="operation_admin_name">操作人</el-checkbox>
                    <el-checkbox label="deposit_shop_name">寄存门店</el-checkbox>
                    <el-checkbox label="buying_price">进货单价</el-checkbox>
                    <el-checkbox label="buying_price_total">进货价合计</el-checkbox>
                </el-checkbox-group>
                <h3>请选择导出报表的文件格式</h3>
                <el-radio v-model="qm_export_type" label="1">excel表格</el-radio>
                <el-radio v-model="qm_export_type" label="2">pdf文件</el-radio>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                loading: false,
                shop_list: [],
                store_list: [],
                goods_type_list: [],
                operator_list: [],
                qm_list_form: {
                    start_date: '',
                    end_date: '',
                    shop_id: '',
                    store_id: '',
                    store_disabled: false,
                    goods_type: '',
                    relation_id: '',
                    mobile: '',
                    content: '',
                    select: 'take_admin_name',
                    take_operation_admin_id: ''
                },
                qm_deposit_sign: false,
				qm_deposit_all: false,
                qm_deposit_ids: [],
                qm_deposit_names: '',
				qm_list: [],
				qm_list_page: 1,
                qm_list_total: 0,
                qm_export_sign: false,
				qm_export_all: false,
                qm_export_ids: [],
                qm_export_list: ['time', 'take_admin_name', 'take_admin_mobile', 'room_name', 'relation_id', 'mobile', 'goods_type_name', 'goods_name', 'goods_unit_name', 'quantity', 'shop_name', 'store_name', 'operation_admin_name', 'deposit_shop_name', 'buying_price', 'buying_price_total'],
                qm_export_type: '1',
                qm_quantity_total: '',
                qm_buying_price_total: '',
            }
        },
        mounted: function() {
            // 日期
            this.qm_list_form.start_date = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            this.qm_list_form.end_date = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            this.innitDate();
            new Promise(resolve => {
                this.getShop(resolve)
            }).then(res => {
                this.qm_list_form.shop_id = this.shop_list[0].id;
                this.getStore(this.shop_list[0].id);
                this.getOperator(this.shop_list[0].id);
                this.getGoodsType();
                this.getQmList(1);
            })
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.qm_list_form.start_date = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.qm_list_form.end_date = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.qm_list_form.start_date = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.qm_list_form.end_date = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                const _this = this;
                $(_this.$refs.qm_list_date).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().hour(8).minute(0).toDate(),
                    endDate: moment().add(1, 'day').hour(8).minute(0).toDate(),
                    dateLimit: {
                        days: 31
                    },
                }, function(start, end, label) {
                    _this.qm_list_form.start_date = start.format('YYYY-MM-DD HH:mm');
                    _this.qm_list_form.end_date = end.format('YYYY-MM-DD HH:mm');
                });
            },
            // 初始化门店输入框
            getShop: function(resolve) {
                const _this = this;

                Vue.axios.post('PublicData/api_getShopListByPurview', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result;
                        _this.shop_list.shift();
                        _this.setShopDefaultTime(_this.shop_list[0].id)
                        resolve()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
            // 仓库数据
            getStore: function(shop_id) {
                const _this = this;

                if(shop_id == '') {
                    _this.qm_list_form.store_id = '';
                    _this.qm_list_form.store_disabled = true;
                } else {
                    _this.qm_list_form.store_id = '';
                    _this.qm_list_form.store_disabled = false;
                    Vue.axios.post('PublicData/api_getStoreList', {
                        "header": Vue.request_header,
                        "request": {
                            "param": {
                                "shop_id": shop_id
                            }
                        },
                        "comment": ""
                    })
                    .then(res => {
                        if(res.data.response.result_code == "true") {
                            _this.store_list = res.data.response.result;
                        } else {
                            Vue.timeoutfun(res.data.response.result_status, _this);
                            layer.msg(res.data.response.error_msg);
                        }
                    })
                    .catch(err => {
                        layer.msg('出错啦');
                    });
                }
            },
            // 商品类型
            getGoodsType: function() {
                const _this = this;

                Vue.axios.post('PublicData/api_getGoodsType', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.goods_type_list = res.data.response.result.data;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
            // 操作人
            getOperator: function(shop_id) {
                const _this = this;

                _this.qm_list_form.take_operation_admin_id = ''
                Vue.axios.post('User/getList', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.operator_list = res.data.response.result.user_info;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },



            // 更换取酒门店
            shopChange(val) {
                this.getStore(val)
                this.getOperator(val)
                this.setShopDefaultTime(val)
            },
            // 寄存门店
            qmDepositSelect() {
                const _this = this;
                const c_qm_deposit_ids = _this.qm_deposit_ids,
                    c_qm_deposit_sign = _this.qm_deposit_sign,
                    c_qm_deposit_all = _this.qm_deposit_all;
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['选择寄存门店', true],
                    area: ['600px', ''], // 宽高
                    content: $(_this.$refs.qm_deposit_shop),
                    cancel: function() {
                        // 右上角关闭
                        _this.qm_deposit_ids = c_qm_deposit_ids;
                        _this.qm_deposit_sign = c_qm_deposit_sign;
                        _this.qm_deposit_all = c_qm_deposit_all;
                    }
                }, function() {
                    let arr = [];
                    _this.shop_list.forEach(item => {
                        _this.qm_deposit_ids.forEach(sub => {
                            if(item.id == sub) {
                                arr.push(item.name);
                            }
                        });
                    });
                    _this.qm_deposit_names = arr.join(',');
                    layer.closeAll();
                }, function() {
                    _this.qm_deposit_ids = c_qm_deposit_ids;
                    _this.qm_deposit_sign = c_qm_deposit_sign;
                    _this.qm_deposit_all = c_qm_deposit_all;
                });
            },
            qmDepositDel() {
				this.qm_deposit_sign = false;
                this.qm_deposit_all = false;
				this.qm_deposit_ids = [];
            },
            qmDepositAll(val) {
                let ids = [];
				this.shop_list.forEach(v => {
					ids.push(v.id);
				});
				this.qm_deposit_ids = val ? ids : [];
				this.qm_deposit_sign = false;
			},
			qmDepositChange(val) {
				const len = val.length;
				this.qm_deposit_sign = len > 0 && len < this.shop_list.length;
				this.qm_deposit_all = len === this.shop_list.length;
            },
            // 列表
            getQmList(page) {
				const _this = this;

                _this.loading = true;
                let take_admin_name = "",
                    take_admin_mobile = "";
                if(_this.qm_list_form.select == 'take_admin_name') {
                    take_admin_name = _this.qm_list_form.content;
                } else if(_this.qm_list_form.select == 'take_admin_mobile') {
                    take_admin_mobile = _this.qm_list_form.content;
                }
				Vue.axios.post('FinanceReport/getTakeDepositDetailList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
                            "start_date": _this.qm_list_form.start_date,
                            "end_date": _this.qm_list_form.end_date,
                            "deposit_shop_id": _this.qm_deposit_ids,
                            "shop_id": _this.qm_list_form.shop_id,
                            "store_id": _this.qm_list_form.store_id,
                            "goods_type": _this.qm_list_form.goods_type,
                            "relation_id": _this.qm_list_form.relation_id,
                            "mobile": _this.qm_list_form.mobile,
                            "take_admin_name": take_admin_name,
                            "take_admin_mobile": take_admin_mobile,
                            "take_operation_admin_id": _this.qm_list_form.take_operation_admin_id
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.qm_list_total = Number(res.data.response.result.count);
							_this.qm_quantity_total = res.data.response.result.quantity_total;
							_this.qm_buying_price_total = res.data.response.result.buying_price_total;
						}
						_this.qm_list = res.data.response.result.data;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},
			// 查询
			qmQuery() {
				this.getQmList(1);
            },
            // 导出
            qmExportAll(val) {
				this.qm_export_ids = val ? this.qm_export_list : [];
				this.qm_export_sign = false;
			},
			qmExportChange(val) {
				const len = val.length;
				this.qm_export_all = len === this.qm_export_list.length;
				this.qm_export_sign = len > 0 && len < this.qm_export_list.length;
			},
            qmExportSet: function() {
                const _this = this;

                Vue.axios.post('FinanceReport/getExportSet', {
					"header": Vue.request_header,
					"request": {
						"param": {
                            "report_type": "FinanceReport/detailCommonExport?bill_type=take_deposit"
                        }
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(res.data.response.result) {
                            _this.qm_export_ids = res.data.response.result.export_fields;
                            _this.qm_export_type = res.data.response.result.export_type;
                        } else {
                            _this.qm_export_ids = _this.qm_export_list;
                            _this.qm_export_type = '1';
                        }
                        _this.qmExportChange(_this.qm_export_ids);
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['800px', ''], // 宽高
                    content: $(_this.$refs.qm_list_export)
                }, function() {
                    _this.qmExport();
                });
            },
            qmExport: function() {
                let take_admin_name = "",
                    take_admin_mobile = "";
                if(this.qm_list_form.select == 'take_admin_name') {
                    take_admin_name = this.qm_list_form.content;
                } else if(this.qm_list_form.select == 'take_admin_mobile') {
                    take_admin_mobile = this.qm_list_form.content;
                }
                window.location.href = Vue.ctUrl + "FinanceReport/detailCommonExport?bill_type=take_deposit" +
                    "&start_date=" + this.qm_list_form.start_date +
                    "&end_date=" + this.qm_list_form.end_date +
                    "&deposit_shop_id=" + this.qm_deposit_ids +
                    "&shop_id=" + this.qm_list_form.shop_id +
                    "&store_id=" + this.qm_list_form.store_id +
                    "&goods_type=" + this.qm_list_form.goods_type +
                    "&relation_id=" + this.qm_list_form.relation_id +
                    "&mobile=" + this.qm_list_form.mobile +
                    "&take_admin_name=" + take_admin_name +
                    "&take_admin_mobile=" + take_admin_mobile +
                    "&export_fields=" + JSON.stringify(this.qm_export_ids) +
                    "&export_type=" + this.qm_export_type;
                layer.closeAll();
                layer.msg("导出成功！");
            },
        }
    }
</script>
<style lang="less" scoped>
    
</style>